import React from "react";
import Container from "../Container";
import Button from "../Button";
import missionVision from "../../assets/timline.png";

export default function MissionVisionSection() {
  return (
    <section id="apropos" className="py-8 md:py-12 lg:py-16 lg:pt-8 lg:pb-0">
      <Container>
        <div className="relative">
          <div className="flex absolute px-7 flex-col gap-6">
            <div className="z-10">
              <p className="text-xs md:text-sm font-bold font-inter text-[#008180] mb-4 md:mb-6 lg:mb-8 uppercase tracking-wider">
                MISSION VISION DE EASY SUITE
              </p>
              <h2 className="text-2xl md:text-3xl lg:text-[38px] font-extrabold text-[#000000] mb-4 md:mb-6 lg:mb-8 leading-[-3%]">
                Simplifier la gestion de votre activité
              </h2>
              <p className="text-sm md:text-base text-[#64607D] leading-[44px] font-medium font-manrope tracking-[-2%]">
                Centraliser toutes vos applications métiers sur une plateforme
                intuitive et accessible pour vous <br /> permettre de gagner en
                efficacité et en productivité.
              </p>
            </div>
            <div className="mt-auto pt-5 md:pt-10">
              <Button className="btn-orange px-6 py-3 rounded-full font-semibold text-white/70">
                Commencer
              </Button>
            </div>
          </div>
          <div className="w-full h-full hidden md:block">
            <img src={missionVision} alt="Mission Vision Easy Suite" />
          </div>
        </div>
      </Container>
    </section>
  );
}
